module.exports = __webpack_public_path__ + "img/5.775b6c82.jpg";